import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import heroImage from '../../assets/corego-success-story-banner.webp';

import quoteImg from '../../assets/corego-success-story-quote.png';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStoryCoregoPage.css';

export const SuccessStoryCoregoPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStoryCorego.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'SuccessStoryCorego.schemaDescription',
  });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const MAX_MOBILE_SCREEN_WIDTH = 962;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStoryCoregoPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroSection}>
            <div className={css.heroSectionLeft}>
              <div className={css.heroSectionBreadcrumbs}>
                <NamedLink name="SuccessStoriesPage">
                  <FormattedMessage id="SuccessStoryCorego.heroBreadcrumbs1" />
                </NamedLink>
                <FormattedMessage id="SuccessStoryCorego.heroBreadcrumbs2" />
                <FormattedMessage id="SuccessStoryCorego.heroBreadcrumbs3" />
              </div>
              {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.heroSectionMobile}>
                  <img
                    src={heroImage}
                    alt="Hero"
                    className={css.proInfoSectionContentImage}
                    loading="lazy"
                  />
                </div>
              ) : null}
              <div className={css.heroSectionTitle}>
                <FormattedMessage id="SuccessStoryCorego.heroTitle" />
              </div>
              <div className={css.heroSectionText}>
                <FormattedMessage id="SuccessStoryCorego.heroText" />
              </div>
              <div className={css.heroSectionTags}>
                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryCorego.heroTag1" />
                </div>

                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryCorego.heroTag2" />
                </div>
              </div>
            </div>
            {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
              <div className={css.heroSectionRight}>
                <img
                  src={heroImage}
                  alt="Hero"
                  className={css.proInfoSectionContentImage}
                  loading="lazy"
                />
              </div>
            ) : null}
          </div>
          <div className={css.sections}>
            <div className={css.contentSection}>
              <div className={css.contentSectionContent}>
                <div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionTitle1" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryCorego.contentSectionParagraph11"
                        values={{
                          a: chunks => (
                            <a
                              href="https://corego.fi/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionTitle2" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryCorego.contentSectionParagraph21"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                  </article>
                  {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                    <div className={css.contentSectionCTAmobile}>
                      <div className={css.contentSectionCTAtitle}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                      </div>
                      <div className={css.contentSectionCTAtext}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                      </div>
                      <div className={css.contentSectionCTAbutton}>
                        <ExternalLink
                          className={css.contentSectionContactButton}
                          onClick={handleShowSpaceHome}
                        >
                          <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                        </ExternalLink>
                      </div>
                    </div>
                  ) : null}
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionTitle3" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph31" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Hanna Maria Pinta"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph32Quote" />
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph32Name" />
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph32Company" />
                    </div>
                  </div>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph32" />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionTitle4" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph41" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Hanna Maria Pinta"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph42Quote" />
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph42Name" />
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph42Company" />
                    </div>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionTitle5" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionParagraph51" />
                    </p>
                  </article>
                  <div className={css.articleSectionResults}>
                    <div className={css.articleSectionResultsTitle}>
                      <FormattedMessage id="SuccessStoryCorego.contentSectionResultsTitle" />
                    </div>
                    <ul className={css.articleSectionResultsList}>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryCorego.contentSectionResultsListItem1"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryCorego.contentSectionResultsListItem2"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryCorego.contentSectionResultsListItem3"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.contentSectionCTAbar}>
                  <div className={css.contentSectionCTA}>
                    <div className={css.contentSectionCTAtitle}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                    </div>
                    <div className={css.contentSectionCTAtext}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                    </div>
                    <div className={css.contentSectionCTAbutton}>
                      <ExternalLink
                        className={css.contentSectionContactButton}
                        onClick={handleShowSpaceHome}
                      >
                        <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                      </ExternalLink>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <ContactPreFooter />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

SuccessStoryCoregoPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { number, shape } = PropTypes;

SuccessStoryCoregoPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStoryCoregoPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(SuccessStoryCoregoPageComponent);

export default SuccessStoryCoregoPage;
